import { createIntl, createIntlCache } from 'react-intl';
import { mapValues } from 'lodash';
import { DEFAULT_LOCALE, Locale, } from '../constants/general';
import { defaultRichTextElements } from '../../../modules/core/components/with-providers/with-providers';
import { locales } from '../constants/locale-map';
class LocaleService {
    constructor() {
        this.cache = createIntlCache();
        this._translations = mapValues(Locale, () => ({}));
        this._instance = this.createInstance();
    }
    async setLocale(l) {
        const locale = l === Locale.test ? Locale['en-test'] : l;
        if (this._locale !== locale) {
            this._locale = locale;
            await this.getTranslations(locale);
            this._instance = this.createInstance(locale, this._translations[locale]);
        }
        return this._translations[locale];
    }
    get instance() {
        return this._instance;
    }
    get translations() {
        return this._translations;
    }
    get messages() {
        return this._translations[this._locale];
    }
    get locale() {
        return this._locale;
    }
    formatMessageById(id, values, defaultMessage) {
        const message = this.instance.formatMessage({ id, defaultMessage }, values);
        return message !== id ? message : undefined;
    }
    // this method needed for adding extension translations in the global object
    updateTranslations(translations) {
        Object.keys(this._translations).forEach((key) => {
            this._translations[key] = {
                ...this._translations[key],
                ...translations[key],
            };
        });
        this._instance = this.createInstance(this._locale, {
            ...this._translations[DEFAULT_LOCALE],
            ...this._translations[this._locale],
        });
    }
    // this method mostly code moved from global.locale => asyncLocaleLoader
    async getTranslations(locale) {
        const defaultStrings = await this.importLocale(DEFAULT_LOCALE);
        // Caching for ReactIntl
        this._translations[Locale.en] = defaultStrings;
        if (locale === Locale.en)
            return defaultStrings;
        // Removed object assign because it handled by $translate it self(fallbackLanguage).
        // And there was a bug, when prev location is stucking if in new we don't have translation for current locale
        // Without object assign it looks like it was fixed
        const localeStrings = await this.importLocale(locale);
        // It's required to combine strings for ReactIntl
        this._translations[locale] = { ...defaultStrings, ...localeStrings };
        return this._translations[locale];
    }
    async importLocale(locale) {
        const { fileName } = locales[locale];
        return (await import(`../../../../locale/${fileName}.json`)).default;
    }
    createInstance(locale = DEFAULT_LOCALE, messages = {}) {
        return createIntl({
            locale,
            messages,
            defaultLocale: DEFAULT_LOCALE,
            defaultRichTextElements,
        }, this.cache);
    }
}
export const localeService = new LocaleService();
export default localeService;
